import { Tooltip as RadixTooltip } from "radix-ui";

import { css, cx } from "~/styled-system/css";

const contentStyles = css({
  layerStyle: "blur-md",
  backgroundColor: "$surface.overlay",

  zIndex: "$tooltip",
  padding: "8px 12px",
  maxWidth: "260px",

  borderRadius: "6px",

  textStyle: "body-3-subtle",
  color: "$gray.200",

  transformOrigin: "var(--radix-tooltip-content-transform-origin)",
  animationDuration: "200ms",
  animationTimingFunction: "cubic-bezier(0.16, 1, 0.3, 1)",
  willChange: "transform, opacity",

  '&[data-state="delayed-open"]': {
    animationName: "tooltipShow",
  },
  '&[data-state="closed"]': {
    animationName: "tooltipHide",
  },

  // Directional animations for better collision handling
  '&[data-state="delayed-open"][data-side="top"]': {
    animationName: "tooltipShowUp",
  },
  '&[data-state="delayed-open"][data-side="bottom"]': {
    animationName: "tooltipShowDown",
  },
  '&[data-state="delayed-open"][data-side="left"]': {
    animationName: "tooltipShowLeft",
  },
  '&[data-state="delayed-open"][data-side="right"]': {
    animationName: "tooltipShowRight",
  },
});

export interface TooltipProps
  extends Omit<RadixTooltip.TooltipContentProps, "children" | "content"> {
  children: React.ReactNode;
  content: React.ReactNode;
  delayDuration?: number;
}

export function Tooltip({
  children,
  content,
  side = "top",
  align = "center",
  sideOffset = 5,
  alignOffset = 0,
  delayDuration = 200,
  className,
  ...props
}: TooltipProps) {
  return (
    <RadixTooltip.Provider>
      <RadixTooltip.Root delayDuration={delayDuration}>
        <RadixTooltip.Trigger asChild>{children}</RadixTooltip.Trigger>
        <RadixTooltip.Portal>
          <RadixTooltip.Content
            {...props}
            side={side}
            align={align}
            sideOffset={sideOffset}
            alignOffset={alignOffset}
            className={cx(contentStyles, className)}
          >
            {content}
          </RadixTooltip.Content>
        </RadixTooltip.Portal>
      </RadixTooltip.Root>
    </RadixTooltip.Provider>
  );
}
